import { Fragment } from 'react'
import { recordOrigin } from '../lib/origin'

// The breadcrumbs of a record (release 3.3, Back model B2 and B4): where the
// page sits, by name, never by a code; the page itself last, not a link. The
// first crumb is the list the record was opened from, with its filters, when
// there was one (lib/origin.ts), and the record's normal place otherwise.
export function Crumbs({
  className,
  home,
  trail = [],
  current,
}: {
  className: string
  // The record's normal place, used when it was opened from a link.
  home: { label: string; href: string }
  trail?: { label: string; href: string }[]
  current: string
}) {
  const first = recordOrigin() ?? home
  return (
    <nav className={className} aria-label="Breadcrumb">
      <a href={first.href}>{first.label}</a>
      {trail.map((t) => (
        <Fragment key={t.href}>
          <span aria-hidden="true"> / </span>
          <a href={t.href}>{t.label}</a>
        </Fragment>
      ))}
      <span aria-hidden="true"> / </span>
      <span aria-current="page">{current}</span>
    </nav>
  )
}
